import { type Address, getAddress } from 'viem'

export type VaultIdentity = { address: Address; chainId: number }

/**
 * Canonical composite key for chain-scoped addresses (vaults, tokens, oracles, …).
 *
 * Always normalizes the address via `getAddress` so producers and consumers
 * compare equal regardless of the input casing.
 */
export function vaultKey({ chainId, address }: { chainId: number; address: Address }): string {
  return `${chainId}:${getAddress(address)}`
}
